<template>
  <v-card>
    <v-card-text id="gdprContainer">
      <p>
        We hebben meer informatie van je nodig voordat we je account kunnen
        aanmaken.
      </p>
      <p>Dit platform verzamelt en verwerkt je persoonlijke informatie.</p>
      <p>
        We gebruiken deze informatie uitsluitend om je ervaring op het platform
        te personaliseren, en om de berichten die je maakt te koppelen aan uw
        gebruikersaccount. Tijdens de registratie stap hebben we je gevraagd een
        gebruikersnaam en een e-mail adres te geven, Je kunt optioneel
        aanvullende informatie toevoegen om uw gebruikersprofiel op deze website
        volledig te maken. Deze informatie wordt nooit gebruikt voor commerciële
        doeleinden.
      </p>
      <p>
        We bewaren deze informatie voor de levensduur van je gebruikersaccount.
        Je kunt je toestemming op ieder moment intrekken door je
        gebruikersaccount te verwijderen. Hoe we met je informatie omgaan kun je
        lezen in de privacy-verklaring (AVG) van Valacon B.V. Ook kun je de
        Algemene Leveringsvoorwaarden van Valacon B.V. raadplegen. Op ieder
        moment kun je een kopie opvragen van je bijdrage aan deze website.
      </p>
      <p>
        Indien je vragen of zorgen hebt, bent je welkom om vragen te stellen aan
        de beheerders van het platform.
      </p>
      <p>
        <v-checkbox
          v-model="gdpr"
          label="Ik geef toestemming voor het verzamelen en verwerken van mijn persoonlijke informatie op deze website."
        />
      </p>
      <p>
        Af en toe kunnen we berichten (notificaties) mailen naar je
        geregistreerde e-mailadres om de voortgang te melden en/of om te
        notificeren dat er nieuwe activiteit is die op jou van toepassing is. Je
        kunt de frequentie daarvan aanpassen (en geheel uitschakelen) en
        selecteren welke notificatie soorten je per e-mail wilt ontvangen, via
        je gebruikersinstellingen pagina. Tenzij expliciet door jou aangepast in
        je gebruikersinstellingen, stuurt het platform je elke samenvatting
        mail. Er is geen vaste frequentie voor het verzenden daarvan.
      </p>
      <p>
        <v-checkbox
          v-model="notifications"
          label="Ik geef toestemming voor het verzenden van samenvattingen en notificaties per e-mail van deze website."
        />
      </p>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        flat
        @click="$emit('decline')"
      >
        {{ $t('message.gdpr_disagree_button') }}
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!gdpr"
        @click="$emit('confirm', notifications)"
      >
        {{ $t('message.gdpr_agree_button') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      gdpr: false,
      notifications: false,
    }
  },
}
</script>
<style lang="less">
#gdprContainer p {
  font-size: 16px;
}
</style>
